import { IOption } from "Dashboard/domain/IOption";
import { useEffect, useState } from "react";
import { resourcesServices } from "../services/resource.service";

export function useResourceOptions() {
  const [options, setOptions] = useState<IOption[]>([]);

  useEffect(() => {
    async function getResources() {
      const resources = await resourcesServices.getResourcesSimpleList();
      const op = resources.map((resource) => {
        return {
          label: resource.nameWithIdentifier,
          value: resource.resourceId,
        };
      });
      setOptions(op);
    }

    try {
      getResources();
    } catch (err) {
      console.log(err);
    }
  }, []);

  return options;
}
